import { If } from "react-conditional-components-renderer";
import classNames from "classnames";
import HTMLReactParser from "html-react-parser";


import styles from "./AscBannerCard.module.scss";
import AscAdminDropdown from "../../AscAdminDropdown/AscAdminDropdown";
import AscHeading from "../../AscTypography/AscHeading/AscHeading";

export interface AscBannerCardProps {
  className?: string;
  size: "small" | "large";
  imageUrl?: string;
  title?: string;
  description: string;
  onEdit?: () => void;
  onDelete?: () => void;
}

export default function AscBannerCard({
  className,
  size,
  imageUrl,
  title,
  description,
  onEdit,
  onDelete,
}: AscBannerCardProps) {
  return (
    <div
      data-testid="asc-banner-card"
      className={classNames(styles.ground, className, {
        [styles.small]: size === "small",
        [styles.large]: size === "large",
      })}
    >
      <If test={size === "large"}>
        {imageUrl && (
          <img src={imageUrl} alt={imageUrl} className={styles.image} />
        )}
      </If>

      <div
        className={classNames(styles.content, {
          [styles.smallContent]: size === "small",
          [styles.largeContent]: size === "large",
        })}
      >
        <If test={size === "small"}>
          <div className={styles.smallBannerTitle}>
            {HTMLReactParser(description)}
          </div>
        </If>

        <If test={size === "large"}>
          {title && (
            <AscHeading className={styles.header}>{title}</AscHeading>
          )}
          <div className={styles.largeBannerTitle}>
            {HTMLReactParser(description)}
          </div>
        </If>

        <AscAdminDropdown
          alignment="right"
          className={classNames(
            styles.moreIcon,
            size === "large" && styles.largeMoreIcon
          )}
        >
          <AscAdminDropdown.Option onClick={onEdit}>
            Edit
          </AscAdminDropdown.Option>
          <AscAdminDropdown.Option onClick={onDelete}>
            Delete
          </AscAdminDropdown.Option>
        </AscAdminDropdown>
      </div>
    </div>
  );
}
